import {
  CreateEventBody,
  DestinationItem,
  DetailEvent,
  EventItem,
  FetchEventParams,
  ListData,
} from "@/types";
import axiosInstance from "./api";

export function fetchListEventService(
  params: FetchEventParams,
): Promise<ListData<EventItem>> {
  return axiosInstance
    .get("/events", { params })
    .then((response) => response.data);
}

export function fetchListDestination(
  keyWord: string,
): Promise<{ destinationDTOList: DestinationItem[] }> {
  return axiosInstance
    .get("/common/destination", { params: { keyWord: keyWord || undefined } })
    .then((response) => response.data);
}

export function deleteEventService(id: string): Promise<void> {
  return axiosInstance.delete(`/events/${id}`);
}

export function uploadBannerService(file: File): Promise<string> {
  const formData = new FormData();
  formData.append("fileType", "EVENT_BANNER");
  formData.append("file", file);

  return axiosInstance
    .post("/file/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    })
    .then((response) => response.data);
}

export function createEventService(form: CreateEventBody) {
  return axiosInstance.post("/events", form).then((response) => response.data);
}

export function updateEventService(form: CreateEventBody, id: string) {
  return axiosInstance
    .patch(`/events/${id}`, form)
    .then((response) => response.data);
}

export function detailEventService(id: string): Promise<DetailEvent> {
  return axiosInstance.get(`/events/${id}`).then((response) => response.data);
}

export function changeStatusActiveEvent(active: boolean, id: string) {
  return axiosInstance.patch(`/events/${id}/active`, undefined, {
    params: { active },
  });
}
